<script lang="ts" setup>
import { inject } from "vue";
import { useRouter } from "vue-router";
import { Translation } from "vue-i18n";
import KlereoAlert from "@/shared/components/KlereoAlert.vue";
import config from "@/config.ts";
import { useBrowse } from "@/shared/mixins/useLink.ts";

const router = useRouter();
const token = inject("token");
const browse = useBrowse();

defineProps<{ connected: boolean }>();
</script>

<template>
  <KlereoAlert v-if="!connected">
    {{ $t("WifiDisconnectedAlert") }}
  </KlereoAlert>
  <KlereoAlert v-if="connected && !token">
    <Translation keypath="WifiConnectedLogoutAlert">
      <template #connectionLink>
        <a @click="router.push('/')"> {{ $t("ConnectionLink") }}</a></template
      >
      <template #createAccountLink>
        <a
          @click="
            browse({ url: config.externalLinksRoot + '/v1/?page=register' })
          "
        >
          {{ $t("CreateAccountLink") }}</a
        ></template
      >
    </Translation>
  </KlereoAlert>
</template>
